<template>
  <section class="apresentacao" id="apresentacao">
    <div class="conteudo">
      <h2>BUSCAR <span>CLÍNICA</span> CERCA DE MI</h2>
      <p>Encuentra una clínica más cerca para realizarse <br class="mobile-br">un análisis con Oligocheck</p>
      <InputBuscaHome v-model="searchQuery" @search="startSearch" :is-loading="isLoading">
        <div v-if="filteredPaises.length && searchQuery.length > 0" class="autocomplete-list">
          <ul>
            <li v-for="pais in filteredPaises" :key="pais" @click="selectPais(pais)">
              {{ pais }}
            </li>
          </ul>
        </div>
      </InputBuscaHome>
    </div>
    <img src="https://socheck.nyc3.cdn.digitaloceanspaces.com/imagens-white/divisor-branco.png" class="divisor" />
  </section>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import InputBuscaHome from "@/components/global/inputs/InputBuscaHome.vue";
import { paises } from '@/data/paises.js';

const searchQuery = ref("");
const isLoading = ref(false);
const router = useRouter();

const startSearch = () => {
  if (searchQuery.value.trim() === '' || isLoading.value) return;

  isLoading.value = true;
  setTimeout(() => {
    router.push({ name: 'busca', query: { city: searchQuery.value.trim() } });
    isLoading.value = false;
  }, 3000);
};

const filteredPaises = computed(() => {
  if (isLoading.value || searchQuery.value === '') {
    return [];
  }
  return paises.filter(pais =>
    pais.toLowerCase().includes(searchQuery.value.toLowerCase())
  ).slice(0, 5);
});

const selectPais = (pais) => {
  searchQuery.value = pais;
  startSearch();
};
</script>

<style scoped>
.autocomplete-list {
  position: absolute;
  background-color: #ffffff;
  border-radius: 30px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  margin-top: 3px;
  padding: 10px 0;
  border: 1px solid #e0e0e06d;
}

.autocomplete-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.autocomplete-list li {
  padding: 10px 25px;
  cursor: pointer;
  color: var(--cor-preto);
  font-family: var(--regular);
  font-size: var(--f2);
}

.autocomplete-list li:hover {
  background-color: #f8f8f8;
}

/* Esconde a barra de rolagem */
.autocomplete-list {
  scrollbar-width: none; /* Firefox */
  overscroll-behavior: contain; /* Previne o scroll da página */
}
.autocomplete-list::-webkit-scrollbar {
  display: none; /* Webkit */
}

/* Efeito de fade na parte inferior para indicar mais conteúdo */
.autocomplete-list::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 90%);
  pointer-events: none; /* Garante que o gradiente não bloqueie o clique no último item */
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.mobile-br {
  display: none;
}

section.apresentacao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 160px 80px 150px 80px;
  position: relative;
  background-image: url("https://socheck.nyc3.cdn.digitaloceanspaces.com/imagens-white/fundo-branco.png");
  background-repeat: no-repeat;
  background-size: 110%;
  background-position: center;
}
.conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
}
.tag {
  display: flex;
  align-items: center;
}
.tag img {
  width: 100%;
  max-width: 100px;
  margin: 0 10px 0 0;
}
.tag h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-preto);
}
h2 {
  font-family: var(--bold);
  font-size: var(--f5);
  color: var(--cor-preto);
  text-align: center;
  margin: 20px 0 10px 0;
}
h2 span {
  color: #2280b4;
}
p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-preto);
  text-align: center;
  line-height: 1.5;
  margin: 0 0 20px 0;
}
img.divisor {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
}
@media screen and (max-width: 1000px) {
  section.apresentacao {
    padding: 100px 20px 80px 20px;
    background-size: cover;
  }
  .conteudo {
    max-width: 100%;
  }
  .tag img {
    max-width: 70px;
  }
  .tag h3 {
    font-size: var(--f1);
  }
  h2 {
    font-size: var(--f4);
    width: 100%;
    max-width: 300px;
  }
  p {
    font-size: var(--f1);
    width: 100%;
    max-width: 320px;
  }
  .mobile-br {
    display: inline;
  }
}
</style>
